module.exports = __webpack_public_path__ + "static/media/prompt_logo.4413ace6.jpeg";